import { useQuery } from "@tanstack/react-query";
import { createFileRoute, Link } from "@tanstack/react-router";
import { format } from "date-fns";
import { getPriceUpdateDataByDatePriceUpdateGet } from "@/client-admin";
import { buttonVariants } from "@/components/ui/button";
import { LoadingComponent } from "@/components/LoadingComponent";
import { ReviewPriceUploadData } from "@/components/PriceUpdate/ReviewPriceUploadData";
import { checkSuperUserPermission } from "@/lib/utils";

export const Route = createFileRoute("/_superuser/admin/price-update/")({
  component: PriceUpdatePage,
  beforeLoad: async () => {
    checkSuperUserPermission("price-update");
  },
});

function PriceUpdatePage() {
  const today = format(new Date(), "yyyy-MM-dd");

  const { data: priceUpdateData, isLoading } = useQuery({
    queryKey: ["priceUpdateData", today],
    queryFn: () => getPriceUpdateDataByDatePriceUpdateGet({ date: today }),
  });

  if (isLoading) {
    return <LoadingComponent />;
  }

  return (
    <div className="flex flex-col gap-2">
      {!priceUpdateData?.data && (
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-semibold">Price Update</h1>
          <Link className={buttonVariants()} to="/admin/price-update/upload">
            Upload Price Update File
          </Link>
        </div>
      )}
      {priceUpdateData?.data && <ReviewPriceUploadData getPriceUpdateResponse={priceUpdateData} />}
    </div>
  );
}
